import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Row, Col, Button } from "react-bootstrap";
import PropTypes from "prop-types";

import { FieldRenderer, SelectCalendarFilter } from "../../CustomFields";
import { allGrains } from "../../../../selector/common";
import { commonConstants } from "../../../../constants";
import { convertToOptions } from "../../../../helpers";
import { CustomSelect } from "../../../../Pages/Containers";

const Search = ({
  values,
  touched,
  errors,
  handleBlur,
  setFieldValue,
  submitCount,
  allGrains,
  placeholder,
  toggleModal,
}) => {
  const [grainOptions, setGrainOptions] = useState([]);

  useEffect(() => {
    const updateGrainOptions = () => {
      const allGrainsCopy = { ...allGrains };
      if (values?.daterange?.to - values?.daterange?.from > 24 * 60 * 60) {
        if (values.grain === commonConstants.grain.UNAGGREEGATED) {
          values.grain = commonConstants.grain.MIN15;
        }
        delete allGrainsCopy[0];
      }
      setGrainOptions(convertToOptions(allGrainsCopy, "id", "label"));
    };
    updateGrainOptions();
  }, [values, allGrains]);

  return (
    <div className="search-bar mb-0">
      {/* <pre>{JSON.stringify(values, null, 2)}</pre> */}
      <Row>
        <Col sm="12" lg="4" xl="3">
          <FieldRenderer
            as={SelectCalendarFilter}
            name="daterange"
            label="Date Range"
            placeholder={placeholder?.daterange || "Select Date"}
            value={values?.daterange}
            onBlur={handleBlur}
            error={errors.daterange}
            touched={touched.daterange}
            submitcount={submitCount}
            required
            setFieldValue={setFieldValue}
            labelwidth={12}
            inputwidth={12}
          />
        </Col>

        <Col sm="12" lg="4" xl="2">
          <FieldRenderer
            as={CustomSelect}
            label="Grain"
            name={"grain"}
            options={grainOptions}
            value={values.grain}
            error={errors.grain}
            touched={touched.grain}
            submitcount={submitCount}
            required
            onChange={(value) => {
              setFieldValue("grain", value);
            }}
            labelwidth={12}
            inputwidth={12}
          />
        </Col>
        <Col sm="12" lg="4" xl="2" className="mt-3">
          <Button type="submit" className="ml-2 mt-3">
            Analyse
          </Button>
          <button
            className="pt-2 pointer link link-dark link-button"
            onClick={toggleModal}
            style={{ position: "relative", top: "10px", left: "30px" }}
          >
            Cancel
          </button>
        </Col>
      </Row>
    </div>
  );
};

// PropTypes validation
Search.propTypes = {
  allGrains: PropTypes.array.isRequired,
  toggleModal: PropTypes.func,
  // Add PropTypes validation for Formik props
  values: PropTypes.object,
  placeholder: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitCount: PropTypes.number,
  setFieldValue: PropTypes.func,
};

const mapStateToProps = (state) => ({
  allGrains: allGrains(state),
});

export default connect(mapStateToProps)(Search);
